var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_4405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 8.25971C1.6875 6.68935 2.34598 5.18331 3.51808 4.0729C4.69019 2.96248 6.2799 2.33866 7.9375 2.33866C9.5951 2.33866 11.1848 2.96248 12.3569 4.0729C13.529 5.18331 14.1875 6.68935 14.1875 8.25971C14.1875 9.83008 13.529 11.3361 12.3569 12.4465C11.1848 13.5569 9.5951 14.1808 7.9375 14.1808C6.2799 14.1808 4.69019 13.5569 3.51808 12.4465C2.34598 11.3361 1.6875 9.83008 1.6875 8.25971ZM17.1117 16.6439L13.6156 13.3326C14.9869 11.9632 15.7509 10.1473 15.75 8.25971C15.75 4.17197 12.2523 0.858398 7.9375 0.858398C3.62266 0.858398 0.125 4.17197 0.125 8.25971C0.125 12.3475 3.62266 15.661 7.9375 15.661C9.5483 15.6621 11.1196 15.1885 12.4336 14.3059L16.0063 17.6912C16.3117 17.9799 16.8063 17.9799 17.1117 17.6912C17.4164 17.4018 17.4164 16.9333 17.1117 16.6439Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_4405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.9c767ef3631f04e0bbff7ac91f6f267b.svg";
export { ForwardRef as ReactComponent };